import { Component } from '@angular/core';
import { DiscordService } from 'app/common/services/discord.service';
import {
  faBackward,
  faForward,
  faPlay,
} from '@fortawesome/free-solid-svg-icons';
import {
  getDatabase,
  ref,
  onValue,
  query,
  limitToLast,
} from 'firebase/database';
import { initializeApp, deleteApp } from 'firebase/app';
import { environment } from 'environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-spotify',
  templateUrl: './spotify.component.html',
  styleUrl: './spotify.component.less',
  imports: [FontAwesomeModule]
})
export class SpotifyComponent {
  tracks: any = [];
  faPlay = faPlay;
  faForward = faForward;
  faBackward = faBackward;
  activeTrack: number = 0;
  swipeCoord: [number, number];
  swipeTime: number;
  firebase: any;
  skip: boolean = false;

    constructor(private discordServive: DiscordService) {
      const firebaseConfig = {
        apiKey: environment.NG_APP_FIREBASE_APIKEY,
        authDomain: environment.NG_APP_FIREBASE_AUTHDOMAIN,
        databaseURL: environment.NG_APP_FIREBASE_DATABASEURL,
        projectId: environment.NG_APP_FIREBASE_PROJECTID,
        storageBucket: environment.NG_APP_FIREBASE_STORAGEBUCKET,
        messagingSenderId: environment.NG_APP_FIREBASE_MESSAGINGSENDERID,
        appId: environment.NG_APP_FIREBASE_APPID,
        measurementId: environment.NG_APP_FIREBASE_MEASUREMENTID,
      };
  
      //init firebase
      this.firebase = initializeApp(firebaseConfig);
      const db = getDatabase();

      //get spotify presence from firebase
      const spotifyPres = query(ref(db, 'presence/spotify/'), limitToLast(1));
      onValue(spotifyPres, (snapshot) => {
        if(!this.skip){
          this.addTrack(snapshot);
        } else {
          this.skip = false;
        }
      });
    }

    ngOnDestroy(): void {
      deleteApp(this.firebase)
    }

    addTrack(track: any) {
      let tracks;
      track.forEach(function (child: any) {
        tracks = child.val();
      });
      if (tracks) {
        this.addNextTrack(tracks);
        // if (this.discordServive.checkDuplicateTracks(tracks)) {
          
        // }
      }
    }
  
    addNextTrack(track: any) {
      var trackInfo = document.getElementById('trackInfo');
      var sliderRight = document.getElementById('sliderRight');
      var sliderLeft = document.getElementById('sliderLeft');
  
      sliderLeft?.setAttribute('class', 'slide-left');
      sliderRight?.setAttribute('class', 'slide-left');
      trackInfo?.setAttribute('class', 'track-left');
      setTimeout(() => {
        this.discordServive.setTracks(track);
        sliderLeft?.setAttribute('class', 'slider_right');
        sliderRight?.setAttribute('class', 'slider_right');
        trackInfo?.setAttribute('class', 'info_right');
      }, 200);
    }
  
    forwardTrack() {
      var sliderLeft = document.getElementById('sliderLeft');
      var sliderRight = document.getElementById('sliderRight');
      var trackInfo = document.getElementById('trackInfo');
  
      sliderLeft?.setAttribute('class', 'slide-left');
      sliderRight?.setAttribute('class', 'slide-left');
      trackInfo?.setAttribute('class', 'track-left');
      setTimeout(() => {
        this.activeTrack--;
        sliderLeft?.setAttribute('class', 'slider_right');
        sliderRight?.setAttribute('class', 'slider_right');
        trackInfo?.setAttribute('class', 'info_right');
      }, 200);
    }
  
    backwardTrack() {
      var sliderRight = document.getElementById('sliderRight');
      var sliderLeft = document.getElementById('sliderLeft');
      var trackInfo = document.getElementById('trackInfo');
  
      sliderRight?.setAttribute('class', 'slide-right');
      sliderLeft?.setAttribute('class', 'slide-right');
      trackInfo?.setAttribute('class', 'track-right');
      setTimeout(() => {
        this.activeTrack++;
        sliderRight?.setAttribute('class', 'slider_left');
        sliderLeft?.setAttribute('class', 'slider_left');
        trackInfo?.setAttribute('class', 'info_left');
      }, 200);
    }
  
    ngOnInit(): void {
      this.tracks = this.discordServive.getTracks();
      if(this.tracks.length > 0){
        this.skip = true;
      }
    }
  
    swipe(e: TouchEvent, when: string): void {
      const coord: [number, number] = [
        e.changedTouches[0].clientX,
        e.changedTouches[0].clientY,
      ];
      const time = new Date().getTime();
  
      if (when === 'start') {
        this.swipeCoord = coord;
        this.swipeTime = time;
      } else if (when === 'end') {
        const direction = [
          coord[0] - this.swipeCoord[0],
          coord[1] - this.swipeCoord[1],
        ];
        const duration = time - this.swipeTime;
  
        if (
          duration < 1000 && //
          Math.abs(direction[0]) > 30 && // Long enough
          Math.abs(direction[0]) > Math.abs(direction[1] * 3)
        ) {
          // Horizontal enough
          const swipe = direction[0] < 0 ? 'next' : 'previous';
          if (swipe === 'next' && this.activeTrack < this.tracks.length - 1) {
            this.backwardTrack();
          } else if (swipe === 'previous' && this.activeTrack > 0){
            this.forwardTrack();
          }
        }
      }
    }

}
